import { useEffect, useState } from "react";
import {
  Container,
  Tabs,
  Tab,
  ListItem,
  ListItemText,
  List,
  Paper,
  Grid,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import {
  emissionTypeDataForMenu,
  months,
  sampleYear,
} from "../../../constants";
import useStyles from "./styles";
import CeroDropdown from "../../../components/CeroDropdown";
import { useDispatch, useSelector } from "react-redux";
import CeroButton from "../../../components/CeroButton";
import EnvironmentalIcon from "../../../assets/icons/EnvironmentalIcon.png";
import SocialIcon from "../../../assets/icons/SocialIcon.png";
import GovernanceIcon from "../../../assets/icons/GovernanceIcon.png";
import activeEnvironmentalIcon from "../../../assets/icons/active-environmental.png";
import activeSocialIcon from "../../../assets/icons/active-social.png";
import activeGovernanceIcon from "../../../assets/icons/active-governance.png";
import { useSnackbar } from "notistack";
import { useLocation, useNavigate } from "react-router-dom";
import { getCookie } from "../../../services/cookie";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const ESGTable = (props) => {
  const { onAddData, onApplyFilter, isDisabled, setEmissionType } = props;
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const classes = useStyles();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const emissionTypePath = pathname.substring(pathname.lastIndexOf("/") + 1);

  const [selectedTopic, setSelectedTopic] = useState(0);
  const readOnlyMode = getCookie("read_only_mode") === "disable_edit";

  const handleTabChange = (event, newValue) => {
    setSelectedTopic(newValue);
    if (newValue === 0) {
      setSelectEmissionType("Environmental");
      navigate(`/emissions/emission-esg/Environmental`);
    } else if (newValue === 1) {
      setSelectEmissionType("Social");
      navigate(`/emissions/emission-esg/Social`);
    } else if (newValue === 2) {
      setSelectEmissionType("Governance");
      navigate(`/emissions/emission-esg/Governance`);
    }
  };
  useEffect(() => {
    if (emissionTypePath === "Environmental") {
      setSelectedTopic(0);
    } else if (emissionTypePath === "Social") {
      setSelectedTopic(1);
    } else if (emissionTypePath === "Governance") {
      setSelectedTopic(2);
    }
  }, []);

  const [emissionType, setEmission] = useState("");
  const headingTitleHandler = (title, id) => {
    setEmissionType(id);
    setEmission(id);
  };
  const [searchText, setSearchText] = useState("");
  const [filterYear, setYear] = useState(null);
  const [filterMonth, setMonth] = useState(null);
  const [filterType, setFilterType] = useState("");
  const [facility, setFacility] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [selectEmissionType, setSelectEmissionType] = useState("Environmental");
  const [lastClickedSubtopic, setLastClickedSubtopic] = useState(null);
  const [currentlyClickedSubtopic, setCurrentlyClickedSubtopic] =
    useState(null);

  const isSocialOrGovernanceAndNotFacilityMgr =
    (window.location.pathname.includes("/Social") &&
      getCookie("role") !== "facility_manager" &&
      getCookie("role") !== "sustainability_manager" &&
      getCookie("role") !== "proxy_sustainability_manager") ||
    (window.location.pathname.includes("/Governance") &&
      getCookie("role") !== "sustainability_manager" &&
      getCookie("role") !== "proxy_sustainability_manager");

  const facilitiesData = useSelector(
    (state) => state.listings.listFacilities.data
  );
  const facilitiesList = facilitiesData.map((item) => ({
    key: item.id,
    value: item.name,
  }));
  const monthOptions = [...months];
  monthOptions.splice(0, 0, { key: "all", value: "All" });
  facilitiesList.splice(0, 0, { key: "all", value: "All" });
  const onApply = () => {
    if (!filterYear) {
      enqueueSnackbar("Please choose a year", {
        variant: "error",
      });
    } else {
      const filterValue = {
        year: filterYear,
        tableShow: true,
      };
      if (searchText) {
        filterValue.search = searchText;
      }
      if (filterMonth !== "all") {
        filterValue.month = filterMonth;
      }
      if (filterType) {
        filterValue.filterType = filterType;
      }
      if (facility !== "all") {
        filterValue.facility_id = facility;
      }
      onApplyFilter(filterValue);
    }
  };

  const iconMapping = {
    Environmental: (
      <img
        src={selectedTopic === 0 ? activeEnvironmentalIcon : EnvironmentalIcon}
        alt="Environmental"
      />
    ),
    Social: (
      <img
        src={selectedTopic === 1 ? activeSocialIcon : SocialIcon}
        alt="Social"
      />
    ),
    Governance: (
      <img
        src={selectedTopic === 2 ? activeGovernanceIcon : GovernanceIcon}
        alt="Governance"
      />
    ),
  };

  const onAddDataClick = () => {
    if (emissionType) {
      onAddData();
    } else {
      enqueueSnackbar("Please select a topic before adding data.", {
        variant: "error",
      });
    }
  };

  const selectEmissionTypeData = (title) => {
    setSelectEmissionType(title);
    navigate(`/emissions/emission-esg/${title}`);
  };

  const handleYearChange = (event) => {
    setYear(event.target.value);
  };

  const handleMonthChange = (event) => {
    setMonth(event.target.value);
  };

  const handleFacilityChange = (event) => {
    setFacility(event.target.value);
  };
  const handleSubtopicClick = (subtopicId, subtopicTitle) => {
    if (currentlyClickedSubtopic === subtopicId) {
      setCurrentlyClickedSubtopic(null);
      setLastClickedSubtopic(null);
      setEmission("");
    } else if (currentlyClickedSubtopic === null) {
      setLastClickedSubtopic(subtopicId);
      setCurrentlyClickedSubtopic(subtopicId);
      headingTitleHandler(subtopicTitle, subtopicId);
    } else {
      setCurrentlyClickedSubtopic(subtopicId);
      setLastClickedSubtopic(null);
      headingTitleHandler(subtopicTitle, subtopicId);
    }
  };
  const firstHalf = emissionTypeDataForMenu[0].subItems[2].subItems.slice(
    0,
    Math.ceil(emissionTypeDataForMenu[0].subItems[2].subItems.length / 2)
  );
  const secondHalf = emissionTypeDataForMenu[0].subItems[2].subItems.slice(
    Math.ceil(emissionTypeDataForMenu[0].subItems[2].subItems.length / 2)
  );

  return (
    <Container className={classes.container}>
      <div className={classes.topBar}>
        <h4 className={classes.mainTitle}>Select ESG Topic</h4>
        <div>
          <CeroButton
            buttonText="Standards Questionnaire"
            className={classes.bulkButton}
            onClick={() => {
              navigate("/emissions/standards-questionnaire");
            }}
          />
          <CeroButton
            buttonText="Production Data"
            className={classes.bulkButton}
            onClick={() => navigate("/production-data-list")}
          />
        </div>
      </div>
      <Paper
        className={classes.containerBox}
        style={{
          backgroundColor: (() => {
            switch (selectedTopic) {
              case 0:
              case 1:
              case 2:
                return "#F8F7F9";
              default:
                return "#E0E0E0";
            }
          })(),

          minHeight: selectedTopic === 0 ? "auto" : "auto",

          paddingBottom: selectedTopic === 0 ? "20px" : "20px",
          width: selectedTopic === 0 ? "90%" : "80%",
          marginBottom: 0,
        }}
      >
        <div className={classes.tabsContainer}>
          <Tabs
            value={selectedTopic}
            className={classes.tabs}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {emissionTypeDataForMenu?.map((topic, index) => (
              <Tab
                className={classes.tabOption}
                key={index}
                style={{
                  backgroundColor:
                    selectedTopic === index ? "#F8F7F9" : "#E0E0E0",
                  color: selectedTopic === index ? "white" : "inherit",
                  flexGrow: 1,
                  border:
                    selectedTopic === index ? "3px solid #5A404E" : "none",
                  borderBottom:
                    selectedTopic === index ? "none" : "3px solid #5A404E",
                }}
                label={
                  <div
                    className={classes.tabLabel}
                    onClick={() => selectEmissionTypeData(topic.title)}
                  >
                    {iconMapping[topic.title]}
                    <span className={classes.tabTitle}>{topic.title}</span>
                  </div>
                }
              />
            ))}
          </Tabs>
          <div className={classes.tabBorder}></div>
        </div>
        {selectedTopic === 0 ? (
          <div className={classes.bottomBox}>
            <div
              style={{
                display: "flex",
                width: "100%",
                gap: "20px",
                marginTop: "20px",
              }}
            >
              {/* Left column: Scope 1 & Scope 2 stacked */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                {/* Scope 1 */}
                <Paper
                  style={{
                    padding: "25px",
                    flex: 1,
                    minWidth: "320px", // for safe wrapping
                    backgroundColor: "rgba(233, 233, 233, 0.78)",
                  }}
                >
                  <ListItem>
                    <ListItemText
                      disableTypography
                      className={classes.headings}
                      primary={
                        <span className={classes.headingText}>Scope 1</span>
                      }
                    />
                  </ListItem>
                  <List className={classes.tabContentBox}>
                    {emissionTypeDataForMenu[0].subItems[0].subItems.map(
                      (heading, index) => (
                        <ListItem
                          key={index}
                          onClick={() =>
                            handleSubtopicClick(heading.id, heading.title)
                          }
                          className={`${
                            currentlyClickedSubtopic === heading.id
                              ? classes.subtopicLabel + " clicked"
                              : classes.subtopicLabel
                          }`}
                        >
                          <span
                            className={classes.subtopicTitle}
                            style={{
                              fontSize: "16px",
                            }}
                          >
                            {heading.title}

                            {heading.tooltip && (
                              <Tooltip
                                title={heading.tooltip}
                                classes={{ popper: classes.tooltip }}
                                arrow
                                placement="right-start"
                              >
                                <InfoOutlinedIcon
                                  className={classes.infoIcon}
                                />
                              </Tooltip>
                            )}
                          </span>
                        </ListItem>
                      )
                    )}
                  </List>
                </Paper>

                {/* Scope 2 */}
                <Paper
                  style={{
                    padding: "25px",
                    flex: 1,
                    minWidth: "320px",
                    backgroundColor: "rgba(233, 233, 233, 0.78)",
                  }}
                >
                  <ListItem>
                    <ListItemText
                      disableTypography
                      className={classes.headings}
                      primary={
                        <span className={classes.headingText}>Scope 2</span>
                      }
                    />
                  </ListItem>
                  <List className={classes.tabContentBox}>
                    {emissionTypeDataForMenu[0].subItems[1].subItems.map(
                      (heading, index) => (
                        <ListItem
                          key={index}
                          onClick={() =>
                            handleSubtopicClick(heading.id, heading.title)
                          }
                          className={`${
                            currentlyClickedSubtopic === heading.id
                              ? classes.subtopicLabel + " clicked"
                              : classes.subtopicLabel
                          }`}
                        >
                          <span
                            className={classes.subtopicTitle}
                            style={{
                              fontSize: "16px",
                            }}
                          >
                            {heading.title}
                            {heading.tooltip && (
                              <Tooltip
                                title={heading.tooltip}
                                classes={{ popper: classes.tooltip }}
                                arrow
                                placement="right-start"
                              >
                                <InfoOutlinedIcon
                                  className={classes.infoIcon}
                                />
                              </Tooltip>
                            )}
                          </span>
                        </ListItem>
                      )
                    )}
                  </List>
                </Paper>
              </div>

              {/* Right column: Scope 3 full height */}
              <Paper
                style={{
                  padding: "2px",
                  flex: 2, // take more space proportionally
                  minWidth: "480px",
                  backgroundColor: "rgba(233, 233, 233, 0.78)",
                }}
              >
                <ListItem>
                  <ListItemText
                    disableTypography
                    className={classes.headings}
                    primary={
                      <span className={classes.headingText}>Scope 3</span>
                    }
                  />
                </ListItem>
                <List className={classes.tabContentBox}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "54% 46%",
                      gap: "16px",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      {firstHalf.map((heading, index) => (
                        <ListItem
                          key={index}
                          onClick={() =>
                            handleSubtopicClick(heading.id, heading.title)
                          }
                          className={`${
                            currentlyClickedSubtopic === heading.id
                              ? classes.subtopicLabel + " clicked"
                              : classes.subtopicLabel
                          }`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "12px",
                          }}
                        >
                          <div
                            className="subtopicTitle"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              flexWrap: "nowrap",
                              fontSize: "16px",
                              whiteSpace: "nowrap", // ⬅️ Ensures icon stays inline
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {heading.title}
                            {heading.tooltip && (
                              <Tooltip
                                title={heading.tooltip}
                                classes={{ popper: classes.tooltip }}
                                arrow
                                placement="right-start"
                              >
                                <InfoOutlinedIcon
                                  className={classes.infoIcon}
                                />
                              </Tooltip>
                            )}
                          </div>
                        </ListItem>
                      ))}
                    </div>
                    <div style={{ flex: 1 }}>
                      {secondHalf.map((heading, index) => (
                        <ListItem
                          key={index}
                          onClick={() =>
                            handleSubtopicClick(heading.id, heading.title)
                          }
                          className={`${
                            currentlyClickedSubtopic === heading.id
                              ? classes.subtopicLabel + " clicked"
                              : classes.subtopicLabel
                          }`}
                        >
                          <span
                            className="subtopicTitle"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              flexWrap: "nowrap",
                              fontSize: "16px",
                            }}
                          >
                            {heading.title}
                            {heading.tooltip && (
                              <Tooltip
                                title={heading.tooltip}
                                classes={{ popper: classes.tooltip }}
                                arrow
                                placement="right-start"
                              >
                                <InfoOutlinedIcon
                                  className={classes.infoIcon}
                                />
                              </Tooltip>
                            )}
                          </span>
                        </ListItem>
                      ))}
                    </div>
                  </div>
                </List>
              </Paper>
            </div>
          </div>
        ) : (
          <div className={classes.bottomBox}>
            <List className={classes.topics}>
              {emissionTypeDataForMenu[selectedTopic].subItems.map(
                (subtopic, index) => (
                  <div key={index}>
                    <ListItem>
                      <ListItemText
                        disableTypography
                        sx={{ lineHeight: "5px !important" }}
                        className={classes.headings}
                        primary={
                          <span className={classes.headingText}>
                            {subtopic.title}
                            <span className={classes.underline}></span>
                          </span>
                        }
                      />
                    </ListItem>
                    <List className={classes.tabContentBox}>
                      {subtopic.subItems.map((heading, index) => (
                        <ListItem
                          key={index}
                          onClick={() =>
                            handleSubtopicClick(heading.id, heading.title)
                          }
                          className={`${
                            currentlyClickedSubtopic === heading.id
                              ? classes.subtopicLabel + " clicked"
                              : classes.subtopicLabel
                          }`}
                        >
                          <span className={classes.subtopicTitle}>
                            {heading.title}
                            {heading.tooltip && (
                              <Tooltip
                                title={heading.tooltip}
                                classes={{ popper: classes.tooltip }}
                                arrow
                                placement="right-start"
                              >
                                <InfoOutlinedIcon
                                  className={classes.infoIcon}
                                />
                              </Tooltip>
                            )}
                          </span>
                        </ListItem>
                      ))}
                    </List>
                  </div>
                )
              )}
            </List>
          </div>
        )}
      </Paper>
      {!showFilter && (
        <Grid
          className={classes.filterContainer}
          container
          columnSpacing={2}
          alignItems="center"
          gap={4}
          justifyContent="center"
          wrap="nowrap"
        >
          {!isDisabled && !isSocialOrGovernanceAndNotFacilityMgr && (
            <Grid item xs={1.5}>
              <CeroButton
                buttonText="Add Data"
                className={`${classes.button} ${
                  !emissionType ? classes.buttonDisabled : ""
                }`}
                onClick={() => {
                  if (!emissionType) {
                    enqueueSnackbar(
                      "Please select a topic to enable this action.",
                      {
                        variant: "error",
                      }
                    );
                  } else {
                    onAddDataClick();
                  }
                }}
              />
            </Grid>
          )}
          {!isDisabled && (
            <Grid item xs={1.5}>
              <CeroButton
                buttonText="View Data"
                className={`${classes.button} ${
                  !emissionType ? classes.buttonDisabled : ""
                }`}
                onClick={() => {
                  if (!emissionType) {
                    enqueueSnackbar(
                      "Please select a topic to enable this action.",
                      {
                        variant: "error",
                      }
                    );
                  } else {
                    setShowFilter(true);
                  }
                }}
              />
            </Grid>
          )}
        </Grid>
      )}
      <Dialog
        open={showFilter}
        onClose={() => setShowFilter(false)}
        maxWidth={false}
        PaperProps={{
          className: classes.dialogPaper,
        }}
      >
        <DialogTitle className={classes.dialogTitle}>
          <div className={classes.dialogTitleText}>
            Please select the year, month and facility to view the data
          </div>
        </DialogTitle>

        <IconButton
          onClick={() => setShowFilter(false)}
          className={classes.closeButton}
          aria-label="close"
        >
          <span style={{ fontSize: "28px", fontWeight: "bold" }}>&times;</span>
        </IconButton>

        <DialogContent>
          <Grid container spacing={2} className={classes.dialogContentGrid}>
            <Grid item xs={12} sm={4}>
              <CeroDropdown
                id="year"
                label="Year"
                fullWidth
                options={sampleYear()}
                onChange={handleYearChange}
                selectedValue={filterYear}
                disabled={isDisabled}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <CeroDropdown
                id="month"
                label="Month"
                fullWidth
                options={monthOptions}
                onChange={handleMonthChange}
                selectedValue={filterMonth}
                disabled={isDisabled}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <CeroDropdown
                id="facility"
                label="Facility"
                fullWidth
                options={facilitiesList}
                onChange={handleFacilityChange}
                selectedValue={facility}
                disabled={isDisabled}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <CeroButton
            buttonText="Proceed"
            className={classes.button1}
            onClick={() => {
              setShowFilter(false);
              onApply();
            }}
          />
          <CeroButton
            buttonText="Cancel"
            className={classes.button2}
            onClick={() => setShowFilter(false)}
          />
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ESGTable;
